import React from "react";
import Mandala from "../decor/Mandala";

/**
 * PageHero - clean, image-free hero band used across sub-pages.
 * Uses a warm cream + subtle gold mandala flourish instead of a background photo.
 */
const PageHero = ({ eyebrow, title, subtitle, children }) => {
  return (
    <section
      className="relative overflow-hidden bg-gradient-to-b from-[#FBF7F0] via-[#F5EED9] to-[#F2E7D5] border-b border-[#D4AF37]/30"
      data-testid="page-hero"
    >
      {/* Mandala accents */}
      <div className="absolute -top-16 -right-16 pointer-events-none animate-mandala-slow opacity-40">
        <Mandala size={280} color="#B65A14" opacity={0.5} />
      </div>
      <div className="absolute -bottom-20 -left-20 pointer-events-none opacity-30">
        <Mandala size={220} color="#D4AF37" opacity={0.6} />
      </div>
      <div className="relative w-full max-w-7xl mx-auto px-4 lg:px-8 py-14 sm:py-16">
        {eyebrow && <div className="overline mb-3 text-[#B65A14]">{eyebrow}</div>}
        <h1
          className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-[#3B2A1A] max-w-3xl mt-10"
          style={{ lineHeight: 1.3 }}
        >
          {title}
        </h1>
        {subtitle && (
          <p className="mt-5 max-w-3xl text-[#3B2A1A]/80 text-base sm:text-lg leading-relaxed">
            {subtitle}
          </p>
        )}
        {children}
      </div>
    </section>
  );
};

export default PageHero;
